"use client";

import { useCallback, useEffect, useState } from "react";
import { isAuthenticated } from "middlewares/auth";
import { getUnreadNotificationsCount } from "services/notificationService";

export const NOTIFICATIONS_CHANGED_EVENT = "notifications:changed";

export const notifyNotificationsChanged = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED_EVENT));
};

export const useUnreadNotifications = () => {
  const [unreadCount, setUnreadCount] = useState(0);

  const refreshUnreadCount = useCallback(async () => {
    if (!isAuthenticated()) {
      setUnreadCount(0);
      return;
    }

    try {
      const data = await getUnreadNotificationsCount();
      setUnreadCount(data.total);
    } catch (error) {
      setUnreadCount(0);
    }
  }, []);

  useEffect(() => {
    refreshUnreadCount();

    window.addEventListener("focus", refreshUnreadCount);
    window.addEventListener(NOTIFICATIONS_CHANGED_EVENT, refreshUnreadCount);

    return () => {
      window.removeEventListener("focus", refreshUnreadCount);
      window.removeEventListener(NOTIFICATIONS_CHANGED_EVENT, refreshUnreadCount);
    };
  }, [refreshUnreadCount]);

  return {
    unreadCount,
    refreshUnreadCount,
  };
};
